/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgOptimizationScale = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.015 1.485H4.5l-.5.5v6.072H2.013l-.5.5V14l.5.5h5.43l.5-.5v-2h6.072l.5-.5V1.985l-.5-.5zM6.942 13.5h-4.43V9.057H4V11.5l.5.5h2.45l-.008 1.5zm0-2.48H5V9.07h1.95l-.008 1.95zm6.573 0H7.942V8.815l3.558-3.6.023 1.25 1-.018-.056-2.925-2.925.056.018 1 1.19-.033-3.475 3.5H5v-5.56h8.515v8.535z"
}));

export default SvgOptimizationScale;